"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _SubdomainsActions = require("../actions/SubdomainsActions");

var _requestStatusSelectors = require("../selectors/requestStatusSelectors");

var _SubdomainsAPI = _interopRequireDefault(require("../api/SubdomainsAPI"));

var fetchSubDomains = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _SubdomainsAPI.default.get,
  initiatingActionType: _SubdomainsActions.SubdomainsActionTypes.FETCH_SUBDOMAINS,
  requestStatusSelector: _requestStatusSelectors.getFetchSubdomainsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _SubdomainsActions.FetchSubdomains
}));

var _default = (0, _reduxObservable.combineEpics)(fetchSubDomains);

exports.default = _default;
module.exports = exports.default;